import React from 'react';
import PropTypes from 'prop-types';

/**
 * Agrupa botones de acción con gap consistente.
 * No cambia handlers: solo layout. Usar en celdas ACC. / toolbars.
 */
const ActionGroup = ({ children, className }) => (
  <div className={'action-group' + (className ? ' ' + className : '')}>
    {children}
  </div>
);

ActionGroup.defaultProps = {
  className: ''
};

ActionGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default ActionGroup;
